// Module
var code = "<viewer-root v-if=\"viewerVisible\" v-on:error=\"onError\"></viewer-root>\n<setup-root v-else-if=\"setupVisible\" v-on:finish=\"onSetupFinish\"></setup-root>\n";
// Exports
export default code;